import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent

@Composable
internal fun TourHandicapDialog(row: TourHandicapDto?, players: List<TourPlayerDto>, values: List<TourHandicapDto>,
    busy: Boolean, error: String?, onClose: () -> Unit, onSave: (String, String, String) -> Unit) {
    var playerId by remember { mutableStateOf(row?.playerId.orEmpty()) }
    val detail = row ?: values.firstOrNull { it.playerId == playerId }
    val playerName = detail?.playerName ?: players.firstOrNull { it.id == playerId }?.name
    var group by remember(playerId) { mutableStateOf(detail?.groupCode.orEmpty()) }
    var reason by remember(playerId) { mutableStateOf(detail?.reason.orEmpty()) }
    val currentBusy by rememberUpdatedState(busy)
    val close by rememberUpdatedState(onClose)
    val valid = playerId.isNotBlank() && reason.trim().length in 1..2000
    DisposableEffect(Unit) {
        val previous = document.activeElement as? HTMLElement
        val overflow = document.body?.style?.getPropertyValue("overflow").orEmpty()
        document.body?.style?.setProperty("overflow", "hidden")
        val listener: (Event) -> Unit = { event ->
            val key = event as? KeyboardEvent
            if (key?.key == "Escape") { key.preventDefault(); if (!currentBusy) close() }
            if (key?.key == "Tab") {
                val fields = document.getElementById("tour-handicap-dialog")?.querySelectorAll("select:not(:disabled),input:not(:disabled),button:not(:disabled)")
                val first = fields?.item(0) as? HTMLElement
                val last = fields?.item((fields.length - 1).coerceAtLeast(0)) as? HTMLElement
                if (first == null) key.preventDefault()
                else if (key.shiftKey && document.activeElement == first) { key.preventDefault(); last?.focus() }
                else if (!key.shiftKey && document.activeElement == last) { key.preventDefault(); first.focus() }
            }
        }
        window.addEventListener("keydown", listener)
        onDispose {
            window.removeEventListener("keydown", listener)
            document.body?.style?.setProperty("overflow", overflow)
            if (previous?.isConnected == true) previous.focus()
        }
    }
    LaunchedEffect(Unit) { (document.querySelector("#tour-handicap-dialog select") as? HTMLElement)?.focus() }
    Div(attrs = { classes("modal-backdrop"); onClick { if (!busy) onClose() } }) {
        Div(attrs = {
            classes("match-modal", "tour-handicap-dialog"); id("tour-handicap-dialog")
            attr("role", "dialog"); attr("aria-modal", "true"); attr("aria-labelledby", "tour-handicap-dialog-title")
            attr("aria-describedby", "tour-handicap-dialog-description"); onClick { it.stopPropagation() }
        }) {
            H2(attrs = { id("tour-handicap-dialog-title") }) { Text(playerName?.let { "Ruční zařazení: $it" } ?: "Ruční zařazení hráče") }
            P(attrs = { id("tour-handicap-dialog-description") }) { Text("Ruční změna se použije pro další nezahájené rundy. Použité handicapy zůstávají uložené u startů.") }
            detail?.let { P(attrs = { classes("muted") }) { Text("Ligový průměr: ${tourAverage(it.sourceAverage)} · po odpočtu: ${tourAverage(it.adjustedAverage)} · vypočtená skupina: ${it.calculatedGroup ?: "—"} · předchozí: ${it.previousGroup ?: "—"}") } }
            TourError(error)
            Form(attrs = { classes("tour-form"); onSubmit { it.preventDefault(); if (!busy && valid) onSave(playerId, group, reason.trim()) } }) {
                if (row == null) TourChoice("Hráč pro ruční zařazení", playerId, listOf("" to "Vyberte hráče") + players.map { it.id to (it.fullName?.takeIf { name -> name.isNotBlank() } ?: it.name) }, busy) { playerId = it }
                TourChoice("Skupina hráče", group, TOUR_GROUPS, busy || playerId.isBlank()) { group = it }
                TourField("Důvod ručního zařazení", reason, busy || playerId.isBlank()) { reason = it }
                Div(attrs = { classes("tour-actions") }) {
                    Button(attrs = { classes("primary"); type(ButtonType.Submit); if (busy || !valid) disabled() }) { Text("Uložit zařazení") }
                    Button(attrs = { type(ButtonType.Button); if (busy) disabled(); onClick { onClose() } }) { Text("Zrušit") }
                }
            }
        }
    }
}
